export default {"src":"https://cdn.jetlend.ru/_next/static/media/№1.829c28a6.svg","height":32,"width":31,"blurWidth":0,"blurHeight":0};